// Converts between dungeon game-pixel coordinates and real-world coordinates,
// using Leaflet's built-in projection API.
//
// Convention:
//   anchor (lat, lng) = the real-world position of game pixel (0, 0) —
//                       the top-left corner of the dungeon grid.
//   gx increases to the right  → east
//   gy increases downward      → south
//
// Scale: 1 game pixel = METERS_PER_PIXEL real-world metres.
// At the default 0.5 m/px a 20 px tile covers ~10 m.

import L from 'leaflet'

export const METERS_PER_PIXEL = 0.5

// Game pixel (gx, gy) → { lat, lng }
export const gamePixelToLatLng = (anchorLat, anchorLng, gx, gy) => {
  const dxM = gx * METERS_PER_PIXEL
  const dyM = gy * METERS_PER_PIXEL
  return {
    lat: anchorLat - dyM / 111320,
    lng: anchorLng + dxM / (111320 * Math.cos(anchorLat * Math.PI / 180)),
  }
}

// Game pixel (gx, gy) → canvas pixel { x, y }
// Leaflet's latLngToContainerPoint handles all the projection math.
export const gameToCanvas = (anchorLat, anchorLng, gx, gy, map) => {
  const { lat, lng } = gamePixelToLatLng(anchorLat, anchorLng, gx, gy)
  const pt = map.latLngToContainerPoint(L.latLng(lat, lng))
  return { x: pt.x, y: pt.y }
}

// Canvas pixel (cx, cy) → game pixel { gx, gy }
export const canvasToGamePixel = (cx, cy, anchorLat, anchorLng, map) => {
  const latlng = map.containerPointToLatLng(L.point(cx, cy))
  return latLngToGamePixel(anchorLat, anchorLng, latlng.lat, latlng.lng)
}

// LatLng → game pixel { gx, gy }
export const latLngToGamePixel = (anchorLat, anchorLng, lat, lng) => {
  const dyM = (anchorLat - lat) * 111320
  const dxM = (lng - anchorLng) * 111320 * Math.cos(anchorLat * Math.PI / 180)
  return {
    gx: Math.round(dxM / METERS_PER_PIXEL),
    gy: Math.round(dyM / METERS_PER_PIXEL),
  }
}
